var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreetIconChild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21.1186L6.56854 0H14.4949L21.172 21.1186H0ZM12.2514 19.454H8.92232L9.19285 15.4374H11.9791L12.2514 19.454ZM11.8895 12.8114H9.28418L9.37378 8.79309H11.7999L11.8895 12.8114ZM11.7086 6.14293H9.46338L9.55299 2.12633H11.5277L11.7086 6.14293Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreetIconChild);
export default __webpack_public_path__ + "static/media/streetIconChild.6c91f9902eb68c71ddc426a1ba956876.svg";
export { ForwardRef as ReactComponent };